import { defineStore } from "pinia";
import { ref } from "vue";

export const useSessionLockStore = defineStore(
  "sessionLock",
  () => {
    const isLocked = ref(false);
    const lockedAt = ref(null);
    const returnPath = ref("/");
    const lastActivityAt = ref(Date.now());

    function lock(path = "/") {
      isLocked.value = true;
      lockedAt.value = Date.now();
      returnPath.value = path || "/";
    }

    function unlock() {
      isLocked.value = false;
      lockedAt.value = null;
      lastActivityAt.value = Date.now();
    }

    function touchActivity() {
      lastActivityAt.value = Date.now();
    }

    function reset() {
      isLocked.value = false;
      lockedAt.value = null;
      returnPath.value = "/";
      lastActivityAt.value = Date.now();
    }

    return {
      isLocked,
      lockedAt,
      returnPath,
      lastActivityAt,
      lock,
      unlock,
      touchActivity,
      reset,
    };
  },
  {
    persist: {
      key: "dq-session-lock",
      pick: ["isLocked", "lockedAt", "returnPath", "lastActivityAt"],
    },
  }
);
